import React from 'react';

import { VOID_FUNCTION } from 'constants/index';
import { Worksheet } from 'constants/routes';
import { useRouteMatch } from 'hooks/useRouteMatch';

import {
  FIELDS_NAME,
  MAX_DATE,
  MIN_DATE,
  VALID_ROUTES_FOR_SHOW,
} from './BlockCarIssueDate.constants';
import { useBlockCarIssueDatePresenter } from './BlockCarIssueDate.presenter';
import * as S from './BlockCarIssueDate.styles';

const { ROUTES } = Worksheet;

export const BlockCarIssueDate = ({
  carInstance,
  errors,
  onPatch = VOID_FUNCTION,
  onSetErrors = VOID_FUNCTION,
}) => {
  const { route } = useRouteMatch({ routes: ROUTES }) ?? {};

  const presenter = useBlockCarIssueDatePresenter({ carInstance, onPatch, onSetErrors });

  if (!VALID_ROUTES_FOR_SHOW.has(route)) {
    return null;
  }

  return (
    <>
      <S.Space4 height="40" />
      <S.GridStyled>
        <S.BlockCarIssueDateHeader>Дата покупки</S.BlockCarIssueDateHeader>
        <S.CarIssueDate
          autoFocus={false}
          buttonDataTest="car-issue-date__calendar-icon"
          dataTest="car-issue-date"
          error={errors[FIELDS_NAME.CAR_ISSUE_DATE]}
          label="Дата покупки"
          maxDate={MAX_DATE}
          minDate={MIN_DATE}
          name={FIELDS_NAME.CAR_ISSUE_DATE}
          value={presenter.value}
          onChange={presenter.onChangeCarIssueDate}
        />
      </S.GridStyled>
    </>
  );
};
